import React, { useEffect } from "react";
import TickImg from "../../Assets/Images/thankyou-tick-green.png";
import GraphImg from '../../Assets/Images/graph_Icon.png'
import { Link, useLocation, useParams } from "react-router-dom";
import Button from "@mui/material/Button";
import useWindowDimensions from "../../Hooks/useWindowDimensions";

const InviteSuccess = () => {
  const { id } = useParams();
  const location = useLocation();
  const data  = location.state?.apiResponse;
  console.log("data", data);
 
  useEffect(() => {
    console.log("data", data);
    // document.body.style.backgroundColor = "#292829";
  }, [data]);

  const handleCopy = (url) => {
    const hostname = window.location.origin;
    console.log("hostname",hostname)
    navigator.clipboard.writeText(hostname+"/"+url);
  };

  return (
    <div className="sucess-thankyou">
      <div className="container thank-you">
        <div className="details-container">
          <div className="tick">
            <img src={TickImg} alt="" />
          </div>
          {/* <div className="tick">&#10003;</div> */}
          <h1>Share the unique link with each 360 Observer</h1>
          {/* <p>
            You'll be notified each time one of your team members takes the test
            so that you can intentionally simplify generosity in your church.
          </p> */}
          {/* <p>You'll be notified as your Board Members take the test so you can review aggregate and individual results.</p> */}
          {/* <p>You'll be notified as your team is taking the test so that
				 you can review aggregate results and individual results.</p> */}
        </div>

        <div className="link-container">
 
           
          <div className="link-list-container">
            {data && data.map((member, index) => (
              <div className="link-item-container" key={index}>
                 <div className="link-list-names" >
                {member.firstName} {member.lastName}
                </div>
                <div   className="link-item" >
                <Link
                rel="noopener noreferrer"
                target="_blank"
                to={`/${member.referrerUrl.replace('test?', '?')}&name=${member.firstName}%20${member.lastName}`}>
                  {`${member.referrerUrl.replace('test?', '?')}&name=${member.firstName}%20${member.lastName}`}
                </Link>
                <button
                class="copy-button"
                onClick={() => handleCopy(`${member.referrerUrl.replace('test?', '?')}&name=${member.firstName}%20${member.lastName}`)}>COPY</button>
                    </div>
              </div>
            ))}
          </div>
        </div>
          <div className="success-back-btn">
            <Link to={"/results/" + id}>back to my results</Link>
          </div>
      </div>

      {/* <div className="schedule-container">
		<img src={GraphImg} alt="" />
        <h4>
          Schedule a call to have our team walk you through your report and see
          how you can accelerate generosity in your church.
        </h4>
        <button className="cta-btn">Schedule a call</button>
      </div> */}
    </div>
  );
};

export default InviteSuccess;
